module.exports = __webpack_public_path__ + "static/media/my-team-edit.a7c687ce.svg";